import request from '@/plugin/axios'
export function getMenu(query) {
  return request({
    url: '/base/sys/menu/list',
    method: 'get',
    params: query
  })
}

export function getMenuSelect(query) {
  return request({
    url: '/base/sys/menu/select',
    method: 'get',
    params: query
  })
}
export function addmenu(data) {
  return request({
    url: '/base/sys/menu/save',
    method: 'post',

    data
  })
}

export function updatemenu(data) {
  return request({
    url: '/base/sys/menu/update',
    method: 'post',

    data
  })
}

export function removeMenu(data) {
  return request({
    url: '/base/sys/menu/delete/' + data,
    method: 'post'

  })
}

export async function getRoleselect(query) {
  return request({
    url: '/base/sys/role/select',
    method: 'get',
    params: query
  })
}

export async function getmenus(query) {
  return request({
    url: '/user/oprSysUser/info',
    method: 'get',
    params: query
  })
}
//公棚赛事权限
export async function getRoundStatus(query) {
  return request({
    // url: '/shed/matchAuth/getRoundStatus',
    url: '/shed/matchAuth/getAuth',
    method: 'get',
    params: query
  })
}
// 获取动态菜单
export function getDynamicMenu() {
  return request({
    url: '/base/sys/menu/navTree',
    method: 'get'
  })
}
